A list of advertisement products with additional context that applies to all products.
